/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AlbumManagementAddImageUploadRequest } from "../models/AlbumManagementAddImageUploadRequest";
import type { AlbumManagementAddImageUploadResponseApiRespoonse } from "../models/AlbumManagementAddImageUploadResponseApiRespoonse";
import type { AlbumManagementDetailAlbumRequest } from "../models/AlbumManagementDetailAlbumRequest";
import type { AlbumManagementDetailAlbumResponseApiRespoonse } from "../models/AlbumManagementDetailAlbumResponseApiRespoonse";
import type { AlbumManagementEditAlbumRequest } from "../models/AlbumManagementEditAlbumRequest";
import type { AlbumManagementEditAlbumResponseApiRespoonse } from "../models/AlbumManagementEditAlbumResponseApiRespoonse";
import type { AlbumManagementListAlbumRequest } from "../models/AlbumManagementListAlbumRequest";
import type { AlbumManagementListAlbumResponseApiRespoonse } from "../models/AlbumManagementListAlbumResponseApiRespoonse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class AlbumManagementService {
  /**
   * List file
   * @param requestBody
   * @returns AlbumManagementAddImageUploadResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static groupAdminAddFileUpload(
    requestBody: AlbumManagementAddImageUploadRequest
  ): CancelablePromise<AlbumManagementAddImageUploadResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/group_admin/add-file-upload",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * List file
   * @param requestBody
   * @returns AlbumManagementListAlbumResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static groupAdminAlbum(
    requestBody: AlbumManagementListAlbumRequest
  ): CancelablePromise<AlbumManagementListAlbumResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/group_admin/album",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Update album
   * @param requestBody
   * @returns AlbumManagementEditAlbumResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static groupAdminAlbumEdit(
    requestBody: AlbumManagementEditAlbumRequest
  ): CancelablePromise<AlbumManagementEditAlbumResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/group_admin/album/edit",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * List file
   * @param requestBody
   * @returns AlbumManagementAddImageUploadResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static groupAdminAlbumAddFileUpload(
    requestBody: AlbumManagementAddImageUploadRequest
  ): CancelablePromise<AlbumManagementAddImageUploadResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/group_admin/album/add-file-upload",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Detail file
   * @param requestBody
   * @returns AlbumManagementDetailAlbumResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static groupAdminAlbumDetail(
    requestBody: AlbumManagementDetailAlbumRequest
  ): CancelablePromise<AlbumManagementDetailAlbumResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/group_admin/album/detail",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }
}
